import { gql } from '@apollo/client';

const organizationFragment = gql`
  fragment OrganizationFields on MddapOrganizationInfo {
    Id
    Name
    IsActive
    OrgUnitCount
  }
`;

export default organizationFragment;
